import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, inject } from "@angular/core";
import { NgZone } from "@angular/core";

interface RotatorImage {
  src: string;
  alt: string;
}

@Component({
  selector: "app-image-rotator",
  standalone: true,
  imports: [],
  templateUrl: "./ImageRotatorComponent.html",
  styleUrl: "./ImageRotatorComponent.scss",
})
export class ImageRotatorComponent implements OnInit, OnDestroy, OnChanges {
  @Input() images: RotatorImage[] = [];
  @Input() intervalMs = 3500;

  activeIndex = 0;
  private rotationHandle?: ReturnType<typeof setInterval>;
  private readonly zone = inject(NgZone);
  private readonly cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.startRotation();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["images"] && !changes["images"].firstChange) {
      this.activeIndex = 0;
      this.startRotation();
    }
  }

  ngOnDestroy(): void {
    this.stopRotation();
  }

  private startRotation(): void {
    this.stopRotation();

    if (!this.images || this.images.length < 2) {
      return;
    }

    this.rotationHandle = this.zone.runOutsideAngular(() =>
      setInterval(() => {
        this.zone.run(() => {
          this.activeIndex = (this.activeIndex + 1) % this.images.length;
          this.cdr.detectChanges();
        });
      }, this.intervalMs),
    );
  }

  private stopRotation(): void {
    if (this.rotationHandle) {
      clearInterval(this.rotationHandle);
      this.rotationHandle = undefined;
    }
  }
}
